import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const SidebarOpenIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 12" fill="none" {...props}>
    <Path
      d="M10 3.96484C10.0006 3.60904 10.4308 3.43105 10.6826 3.68262L12.7168 5.7168C12.8729 5.87295 12.8728 6.126 12.7168 6.28223L10.6826 8.31641C10.4307 8.56831 10.0003 8.39032 10 8.03418V6.75H7.40039C7.1795 6.75 7.00004 6.57049 7 6.34961V5.64941C7.00025 5.42871 7.17963 5.25 7.40039 5.25H10V3.96484Z"
      fill="currentColor"
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 0C14.6569 0 16 1.34315 16 3V9C16 10.6569 14.6569 12 13 12H3L2.8457 11.9961C1.26055 11.9158 0 10.6051 0 9V3C0 1.34315 1.34315 0 3 0H13ZM3 1.5C2.17157 1.5 1.5 2.17157 1.5 3V9C1.5 9.82843 2.17157 10.5 3 10.5H4.25V1.5H3ZM5.75 10.5H13C13.8284 10.5 14.5 9.82843 14.5 9V3C14.5 2.17157 13.8284 1.5 13 1.5H5.75V10.5Z"
      fill="currentColor"
    />
  </Icon>
);
